// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__34rQF","addWidgetButton":"Header_addWidgetButton__15ckq","dashboardTabs":"Header_dashboardTabs__3UtXE","active":"Header_active__2sQ6r"};